// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mr_mime: PokeData = {
  "id": 122,
  "name": "mr-mime",
  "height": 13,
  "weight": 545,
  "base_experience": 161,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FAIRY
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "meditate",
    "mimic",
    "barrier",
    "light-screen",
    "reflect",
    "psywave",
    "substitute",
    "protect",
    "safeguard",
    "baton-pass",
    "encore",
    "trick",
    "role-play",
    "recycle",
    "teeter-dance",
    "iron-defense",
    "magical-leaf",
    "calm-mind",
    "copycat",
    "power-swap",
    "guard-swap",
    "sucker-punch",
    "zen-headbutt",
    "wide-guard",
    "quick-guard",
    "misty-terrain",
    "dazzling-gleam"
  ],
  "moves": [
    "psychic",
    "reflect",
    "psywave",
    "protect",
    "calm-mind",
    "zen-headbutt",
    "misty-terrain",
    "dazzling-gleam",
    "psy-pulse",
    "prismatic-cage",
    "synchronize",
    "hyper-voice",
    "starfall"
  ],
  "evolution_chain": {
    "id": 57,
    "item": {
      "name": "odd-incense"
    },
    "species": [
      {
        "name": "mime-jr",
        "order": 139,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mr-mime",
        "order": 140,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 439,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "mimic"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "mr-rime",
        "order": 866,
        "types": [
          PokeType.ICE,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 122,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 66.25,
    "speed": 90,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
